class VisibleListener {
  constructor (option = {}) {
    this.observer = !!window.IntersectionObserver
    this.registers = []
    this.$reference = option.$reference || window
    this.eventListener = this.listenerScroll.bind(this)
    this.scale = option.scale | 0
  }

  add (target, cb) {
    const event = {
      element: target,
      callback: cb
    }

    if (this.observer) {
      event.io = new IntersectionObserver((entries, observer) => {
        const ratio = Math.floor(entries[0].intersectionRatio * 100)
        const flag = ratio > (this.scale || 0)
        cb(flag)
      }, {
        threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1]
      })

      event.io.observe(target)
    } else {
      if (this.registers.length === 0) {
        this.$reference.addEventListener('scroll', this.eventListener, false)
        window.addEventListener('resize', this.eventListener, false)
      }
    }

    this.registers.push(event)
  }

  remove (target) {
    const event = this.registers.find(item => item.element === target)
    event && event.io && event.io.unobserve(target)

    this.registers = this.registers.filter(item => item.element !== target)

    this.registers.length === 0 && this.clear()
  }

  clear () {
    if (this.observer) {
      this.registers.forEach(event => {
        event.io.disconnect()
      })
    } else {
      this.$reference.removeEventListener('scroll', this.listenerScroll)
      window.removeEventListener('resize', this.listenerScroll)
    }

    this.registers = []
  }

  listenerScroll () {
    this.registers.forEach(item => {
      const offset = item.element.getBoundingClientRect()
      const visible = offset.top + Math.floor(offset.height * this.scale / 100) < window.innerHeight
      item.callback(visible)
    })
  }
}

export default VisibleListener
